import { FC, useEffect, useState } from "react";
import SongContainer from "./components/SongContainer";
import { TAudioTrack } from "../../../../types/audioTrack";

type Props = {
  title?: string;
  audioTracks?: TAudioTrack[] | null;
  contestId?: string;
};

const Playlist: FC<Props> = ({ title, audioTracks, contestId }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [idRow, setIdRow] = useState<string>();
  const [keyRow, setKeyRow] = useState<number>();
  const [filteredTracks, setFilteredTracks] = useState<TAudioTrack[] | null>(
    null
  );

  const handleMouseEnter = (id: string, key: number) => {
    setIdRow(id);
    setKeyRow(key);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const toggleLikeLocal = (trackId: string) => {
    setFilteredTracks((prev) => {
      if (!prev) return null;
      return prev.map((track) =>
        track.id === trackId
          ? {
              ...track,
              isLiked: !track.isLiked,
              likes: track.isLiked ? track.likes - 1 : track.likes + 1,
            }
          : track
      );
    });
  };

  useEffect(() => {
    if (audioTracks) {
      const filtered = audioTracks
        .filter((track) => {
          const firstChar = track.name.split(".")[0][0];
          return !isNaN(Number(firstChar));
        })
        .sort((a, b) => {
          const nameA = a.name.split(".")[0];
          const nameB = b.name.split(".")[0];
          return nameA.localeCompare(nameB, undefined, { numeric: true });
        });

      setFilteredTracks(filtered);
    }
  }, [audioTracks]);

  return (
    <div
      className="pt-8 md:p-8 md:mt-[2rem] rounded-md"
      style={{
        backgroundImage: "linear-gradient(to bottom, #F0F4FF, #F2EDFF)",
      }}
    >
      {audioTracks && (
        <>
          <div>
            <h4 className="text-xl pl-3 pb-[1.5rem] text-black font-bold md:pl-0">
              {title && title}
            </h4>
          </div>
          <div className="flex flex-col items-center w-full">
            {filteredTracks?.map((track, index) => {
              return (
                <div
                  key={index}
                  id={track.id}
                  onMouseEnter={() => handleMouseEnter(track.id, index)}
                  onMouseLeave={handleMouseLeave}
                  className="w-full my-1.5 md:my-0.5"
                >
                  <SongContainer
                    key={track.id}
                    index={index}
                    id={track.id}
                    icon={track.imgPath}
                    trackName={track.name}
                    artist={track.artist.name}
                    like={track.likes}
                    isLiked={track.isLiked}
                    voices={track.voices}
                    playCounter={track.playCounter}
                    length={track.length}
                    arrayLength={audioTracks.length}
                    trackLink={track.audioPath}
                    buttonStates={track.buttonStates ?? "play"}
                    idRow={idRow}
                    keyRow={keyRow}
                    isHovered={isHovered}
                    contestId={contestId}
                    onToggleLike={toggleLikeLocal}
                  />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default Playlist;
